/** localStorage key that persists the internal build's chosen backend environment. */
export const INTERNAL_ENV_STORAGE_KEY = 'eshyft-admin-internal-selected-env';

/** Directory key used when nothing valid is persisted yet. */
export const INTERNAL_ENV_DEFAULT_KEY = 'dev';
